import React, { useState, useEffect } from 'react'
import { Button } from '@mui/material';
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'
import NewForm from './NewForm'
import { PageHeader, StatusBadge } from '../../ui'
import 'react-phone-input-2/lib/high-res.css'
import './User.css'

export default function User() {

  const [createNewFlag, setCreateNewFlag] = useState(false)
  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('')

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role_capabilities?.all_modules_access === true) {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['User_Access Specifier']);
    }

  }, []);


  return (
    <>
      <PageHeader
        title="Users"
        subtitle={createNewFlag
          ? "Create a user and assign the appropriate account and module access."
          : "Review user details, permissions, and account access."
        }
        eyebrow="Administration"
        help={(
          <button type="button" className="btn btn-outline-primary" onClick={() => setLgShow(true)}>
            Help
          </button>
        )}
        actions={accessType === 'View' ? null : createNewFlag ? (
          <Button variant="contained" onClick={() => setCreateNewFlag(false)}>
            Edit User
          </Button>
        ) : (
          <Button variant="contained" onClick={() => setCreateNewFlag(true)}>
            + New User
          </Button>
        )}
      >
        {accessType === 'View' && <StatusBadge status="neutral">View only</StatusBadge>}
      </PageHeader>

      <Modal
              size="lg"
              show={lgShow}
              onHide={() => setLgShow(false)}
              aria-labelledby="user-help-title"

            >
              <Modal.Header closeButton>
                <Modal.Title id="user-help-title" >
                  Instructions to Add/Edit User
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h5>To Create a New user -</h5>
                <ol>
                  <li>Select the account name from the dropdown > Max Number of Users and Existing Number of Users will reflect automatically once account name is selected.  </li>
                  <li>Enter User Email,Contact No.,User Name, role to be assigned and create a password in password field or you can click on Generate Password button so that random password will be created
                  </li>
                  <li>Enter all the mandatory user details > Submit > New user with unique ID has been created.
                  </li>
                </ol>

                <h5>View/Edit Existing user - </h5>
                <ol>
                  <li>To view/edit existing user, select Account name and User Email from drop down > view/edit the user details > submit.
</li>
                  <li><strong>Note:</strong> Company name and user ID fields are non-editable</li>
                </ol>

                <h5>To deactivate the User</h5>
                <ol>
                  <li>User Setup {'>'} Select company name and User Email from drop down.</li>
                  <li>Go to the edit user ID page.</li>
                  <li>Click on deactivate</li>
                </ol>
              </Modal.Body>
      </Modal>

      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : createNewFlag ? (<NewForm />) : <UpdateForm />}

    </>
  );
}
